import { render, staticRenderFns } from "./MaterialNum.vue?vue&type=template&id=3b490fa0"
import script from "./MaterialNum.vue?vue&type=script&lang=js"
export * from "./MaterialNum.vue?vue&type=script&lang=js"
import style0 from "./MaterialNum.vue?vue&type=style&index=0&id=3b490fa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports